import { createPerfilApiClient } from './perfilApiClient';

export default {
    async getParcelas({ page = 1, per_page = 5, search = '' } = {}) {
        try {
            const token = localStorage.getItem('token');
            const tid = localStorage.getItem('hash_teatro');
            const params = {
                page,
                per_page,
                api_key: token,
                ...(tid ? { tid } : {}),
            };
            if (search) params.search = search;
            const response = await createPerfilApiClient().get('/f/perfil/parcelas', { params });

            const data = response.data ?? {};
            const rawItems = data.data ?? data.parcelas ?? data.items ?? [];
            const items = Array.isArray(rawItems) ? rawItems : [];

            const meta = {
                current_page: data.current_page ?? data.meta?.current_page ?? 1,
                last_page: data.last_page ?? data.meta?.last_page ?? 1,
                total: data.total ?? data.meta?.total ?? items.length,
                per_page: data.per_page ?? data.meta?.per_page ?? items.length,
            };

            return { items, meta };
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[parcelas] Error al obtener parcelas:', error);
            }
            throw error;
        }
    },
};
